import { WithAccountId } from '@mews-commander/types';
import { ModalWrapper, NewModalBodyWrapper } from '@mews-commander/ui';
import { TextKey, FeatureFlag } from '@mews-commander/enums';
import { Container } from '@optimus-web/core';
import { useFeatureFlag } from '@mews/framework';
import { CustomerDetailModalHeader } from '../../customerDetail/components/CustomerDetailModalHeader';
import { PaymentSidePanels } from './sidePanels/PaymentSidePanels';
import { PaymentsTablesSegmented } from './tables/PaymentsTablesSegmented';
import { PaymentsTablesProvider } from './tables/PaymentsTablesContext';
import { PaymentsTabActiveSegment } from './tables/types';
import { usePaymentsTabSegmentTitle } from './tables/hooks';

export const CustomerPaymentsTab = ({
    accountId,
    activeSegment,
    contentOnly = false,
}: { activeSegment: PaymentsTabActiveSegment; contentOnly?: boolean } & WithAccountId) => {
    const isNewCustomerPaymentTabRoutesEnabled = useFeatureFlag(FeatureFlag.newCustomerPaymentTabRoutesEnabled);
    const title = usePaymentsTabSegmentTitle({ segment: activeSegment, accountId });

    const content = (
        <Container padding="200">
            <PaymentsTablesProvider>
                <PaymentsTablesSegmented accountId={accountId} segment={activeSegment} />
                <PaymentSidePanels accountId={accountId} />
            </PaymentsTablesProvider>
        </Container>
    );

    if (contentOnly) {
        return content;
    }
    /**
     * There should be no need for custom tabs and headers.
     * They should be handled in a page layout and generated based on route structure.
     * TODO: remove custom wrapper and tabs and render content in a page layout.
     */
    return (
        <ModalWrapper>
            <CustomerDetailModalHeader
                accountId={accountId}
                activeTab={TextKey.PaymentPlural}
                documentTitle={isNewCustomerPaymentTabRoutesEnabled ? title : undefined}
            />
            <NewModalBodyWrapper>{content}</NewModalBodyWrapper>
        </ModalWrapper>
    );
};
